import { useTranslation } from 'react-i18next';
import { Button } from '@/Domain/components/Shared/Button/Button';
import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from '@/Domain/components/Shared/Form/Form';
import { Input } from '@/Domain/components/Shared/Input/Input';
import { Separator } from '@/Domain/components/Shared/Separator/Separator';
import { Switch } from '@/Domain/components/Shared/Switch/Switch';
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from '@/Domain/components/Shared/Tooltip/Tooltip';
import { TrashIcon } from '@/Domain/components/icons/Trash.icon';

type Props = {
  index: number;
  onRemove: (index: number) => void;
};

export const ParameterItemForm = ({ onRemove, index }: Props) => {
  const { t } = useTranslation('campaigns');

  return (
    <div className="grid grid-cols-[minmax(100px,0.75fr)_minmax(150px,1fr)_minmax(100px,0.75fr)_65px_5px_34px] items-start gap-4 border-b border-border px-4 py-3">
      <FormField
        name={`parameters.${index}.name`}
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <Input
                placeholder={t('form.parameter_table.name_placeholder')}
                size="sm"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        name={`parameters.${index}.description`}
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <Input
                placeholder={t('form.parameter_table.description_placeholder')}
                size="sm"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        name={`parameters.${index}.data_format`}
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <Input
                placeholder={t('form.parameter_table.format_placeholder')}
                size="sm"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        name={`parameters.${index}.is_enabled`}
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <Switch
                checked={field.value}
                onCheckedChange={(check) => field.onChange(check)}
                className="mt-[5px]"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <Separator orientation="vertical" />

      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="secondary"
            size="icon"
            type="button"
            className="justify-self-end text-destructive hover:!bg-destructive-muted hover:!text-destructive"
            onClick={() => onRemove(index)}
          >
            <TrashIcon />
          </Button>
        </TooltipTrigger>
        <TooltipContent>{t('tooltip.delete')}</TooltipContent>
      </Tooltip>
    </div>
  );
};
